import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectAccountWebPageCardsListItemsById } from '../../../../../redux/web-page-cards/selector';
import { accountWebPageCards } from '../../../../../redux/web-page-cards/action';
import PageLoader from '../../../../../components/PageLoader';
import { selectAccountWebPagesListItems } from '../../../../../redux/web-pages/selector';
import { accountWebPages } from '../../../../../redux/web-pages/action';
import { accountTypes } from '../../../../../redux/account-types/action';
import { selectAccountTypesListItems } from '../../../../../redux/account-types/selector';
import { selectAccountsListItems } from '../../../../../redux/accounts/selector';
import { accounts } from '../../../../../redux/accounts/action';
import { selectListItems } from '../../../../../redux/library/selector';
import WebPageComponent from '../components/account-web-page.component';

const AgencyAccountWebPage = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const { id } = useParams(); // Retrieve the id parameter from the route	

  const webPageCardsItems = useSelector(selectAccountWebPageCardsListItemsById(id))
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const webPageItems = useSelector(selectAccountWebPagesListItems)
  const accountTypeItems = useSelector(selectAccountTypesListItems)
  const accountItems = useSelector(selectAccountsListItems)
  const libraryData = useSelector(selectListItems)
  const TypeData = libraryData?.result?.Type
  const [selectedWebpages, setSelectedWebpages] = useState<any>([])

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedWebpages({ ...selectedWebpages, [field]: event });
  }

  const listAccountWebPages = () => {
    dispatch(accountWebPageCards.list({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-page-cards/accounts/list`,
      entity: 'accountWebPageCards',
      jsonData: {
        "Filters": [
          {
            "FieldName": "VendorWebPageId",
            "FieldType": "number",
            "FilterOperatorId": 1,
            "FieldValue": parmas?.id
          }
        ],
      }, options: { authorization_required: false }, id: parmas?.id,
    }))
  }

  useEffect(() => {
    listAccountWebPages();
  }, []
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    await dispatch(accountWebPages.resetAction({ actionType: 'create' }))
    await dispatch(accountWebPages.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-page-cards/accounts`, entity: 'accountWebPages', jsonData: {
        Records: [
          {
            "Context": {
              "Subscription": "UCP",
              "Domain": "Commerce",
              "SubDomains": [
                "Retail",
                "F&B",
                "Fashion"
              ],
              "Network": "Vendor",
              "Application": "Management",
              "Channel": "Portal"
            },
            "Message": {
              "AccountTypeId": selectedWebpages?.AccountTypeId,
              "PlatformWebSitePageId": selectedWebpages?.PlatformWebSitePageId,
              "AccountId": selectedWebpages?.AccountId,
              "Remarks": selectedWebpages?.Remarks,
              "HostingUrl": selectedWebpages?.HostingUrl,
              "MappedDomain": selectedWebpages?.MappedDomain,
              "DisplayOrder": selectedWebpages?.DisplayOrder
            }
          }
        ]
      }
    })).then(() => {
      back()
    })
  }

  const back = () => {
    navigate(`/agencies/cms/webpages`)
  }

  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'CardName', headerName: 'CardName',searchField: 'CardName', filter: true,
        filterType: 'text'  },
      { field: 'PageName', headerName: 'PageName',searchField: 'PageName', filter: true,
        filterType: 'text'  },
      { field: 'LayoutName', headerName: 'LayoutName',searchField: 'LayoutName', filter: true,
        filterType: 'text'  },
    ]);
  }

  const handleSearch = (data: any) => {
    console.log('Search data', data)
    let searchCriteria = {};
    if (data?.column){
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }

    dispatch(accountWebPageCards.list({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-page-cards/accounts/list`,
      entity: 'accountWebPageCards',
      jsonData: {
        "Filters": [
          {
            "FieldName": "VendorWebPageId",
            "FieldType": "number",
            "FilterOperatorId": 1,
            "FieldValue": parmas?.id
          }
        ],
        "PageNumber": 1,
        "PageSize": 50,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }, options: { authorization_required: false }, id: parmas?.id,
    }))
  }


  const handleReloadData = () => {
    dispatch(accountWebPageCards.list({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-page-cards/accounts/list`,
      entity: 'accountWebPageCards',
      jsonData: {
        "Filters": [
          {
            "FieldName": "VendorWebPageId",
            "FieldType": "number",
            "FilterOperatorId": 1,
            "FieldValue": parmas?.id
          }
        ],
        "PageNumber": 1,
        "PageSize": 50,
        "SortField": "Id",
        "SortOrder": "desc",
      }, options: { authorization_required: false }, id: parmas?.id,
    }))
  }
  useEffect(() => {
    if (selectedWebpages?.AccountTypeId) {
      const accountTypeName = accountTypeItems?.result?.items.find(
        item => item.Id === selectedWebpages.AccountTypeId
      )?.Name;
      const accountTypeValue = TypeData.find(
        type => type.Text === accountTypeName
      )?.Value;
      dispatch(accountWebPages.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-pages/list`, entity: 'accountWebPages', jsonData: {
          "Filters": [
            {
              "FieldName": "Network",
              "FieldType": "text",
              "FilterOperatorId": 1,
              "FieldValue": accountTypeName
            }
          ],
        }
      })).then(() => {
        dispatch(accounts.list({
          url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts/list`,
          entity: 'accounts',
          jsonData: {
            "Filters": [
              {
                "FieldName": "TypeId",
                "FieldType": "enum",
                "FilterOperatorId": 1,
                "FieldValue": accountTypeValue
              },
              {
                "FieldName": "IsProxyAccount",
                "FieldType": "boolean",
                "FilterOperatorId": 1,
                "FieldValue": false
              }
            ],
          }
        }));
      })
    }
  }, [selectedWebpages?.AccountTypeId]);

  useEffect(() => {
    dispatch(accountTypes.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`, entity: 'accountTypes', jsonData: {
      }
    }))
    if (parmas?.id > 0) {
      createColumnDefs()
      setIsLoading(false)
      ////
    } else {
      setIsLoading(false)
    }
  }, []
  )
  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)

  }
  const handleDelete = (data: any) => {
    dispatch(accountWebPageCards.delete({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-page-cards/accounts/delete`,
      entity: 'accountWebPageCards',
      jsonData: {
        Records: [
          {
            "Context": {},
            "Message": { CardId: data?.Id }
          }
        ]
      }
    })).then(() => {
      listAccountWebPages()
    })
  }

  const additionButtons: any = [
    {
      name: 'Back',
      callback: () => back(),
    },
    {
      svg:
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
      <title>Reload</title>
      <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>,
    // name: 'Reload',
    callback: () => handleReloadData(),
    },
  ];

  const formatPageListData = (data: any) => {
    return _.map(data, (product: any) => {
      const item = {
        Id: product?.Message?.Id,
        PageName: product?.Message?.PageName,
      }
      return item
    });
  }

  useEffect(()=>{
    console.log(webPageCardsItems,'webPageCardsItems')

  },[])

  return (
    <>
      {isLoading ? <PageLoader /> :
        <WebPageComponent
          back={back}
          onDelete={handleDelete}
          onEdit={handleEdit}
          rowData={webPageCardsItems?.items}
          columnDefs={columnDefs}
          additionButtons={additionButtons}
          pages={formatPageListData(webPageItems?.result?.items)}
          accountTypes={accountTypeItems?.result?.items}
          selectedWebpages={selectedWebpages}
          handleInnerFormChange={handleInnerFormChange}
          Id={parmas?.id}
          handleFormSubmit={handleFormSubmit}
          accounts={accountItems?.result?.items}
          onSearch={handleSearch}
        />
      }
    </>
  )
}

export default AgencyAccountWebPage;